<template>
<div v-if="condition" class="mt-4 grid">
<div class="col-11">
<Dropdown  v-model="condition.type" :options="types" optionLabel="name" optionValue="code" class="p-inputtext-sm" placeholder="Etki edecek öğe"/>

<Dropdown :filter="true"  v-if="condition.type=='inputfield'" v-model="condition.inputfield_id" :options="inputfields" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="conditionInputfieldSelected"/>

<Dropdown :filter="true"  v-if="condition.type=='customattribute'" v-model="condition.customattribute_id" :options="customattributes" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="conditionCustomattributeSelected"/>

<Dropdown :filter="true"  v-if="condition.type=='nonconformitytype'" v-model="condition.nonconformitytype_id" :options="nonconformitytypes" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="conditionNonconformityTypeSelected"/>

<Dropdown :filter="true"  v-if="condition.type=='customcalculation'" v-model="condition.customcalculation_id" :options="customcalculations" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="conditionCustomCalculationTypeSelected"/>



<!-- inputfield -->
<template v-if="inputfield">

<template v-if="inputfield.type=='columns'">
, <Dropdown :filter="true"  v-model="condition.inputfieldcolumn_id" :options="inputfield.columns" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="inputfieldColumnSelected"/> 

<template v-if="condition.inputfieldcolumn_id">
	sütunu için girilen değer
</template>
</template>

<template v-else>
<span class="ml-2">sorusu için girilen değer, </span>
</template>

<Dropdown :filter="true"  v-model="condition.comparison_type" :options="comparison_types" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm mt-2" 
/>

<!-- comparison type selected-->
<template v-if="condition.comparison_type">

<template v-if="condition.comparison_type=='inputfield'">

<Dropdown :filter="true"   v-model="condition.comparison_inputfield_id" :options="inputfields" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm  mt-2"  @change="comparisonInputfieldSelected"/>

<Dropdown :filter="true"  v-if="comparisoninputfield && comparisoninputfield.type=='columns'" v-model="condition.comparison_inputfield_column_id" :options="comparisoninputfield.columns" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" /> 
	
</template>

<template v-if="condition.comparison_type=='value'">

<!-- condition value-->
<InputNumber   placeholder="Sayısal değer" v-if="inputfield.type=='number'" v-model="condition.numerical_val" class="ml-2 p-inputtext-sm  mt-2" />

<template v-if="inputfield.type=='columns' && condition.inputfieldcolumn_id">

	<InputNumber  v-if="inputfieldcolumn.type=='number'" placeholder="Sayısal değer"  v-model="condition.numerical_val" class="ml-2 p-inputtext-sm mt-2" />
	<Dropdown :filter="true"  v-if="inputfieldcolumn.type=='select'" v-model="condition.numerical_val" :options="inputfieldcolumn.options" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" /> 

</template>


<InputText  type="text" placeholder="Text değeri" v-if="inputfield.type=='text' || inputfield.type=='longtext'" v-model="condition.text_val" class="ml-2 p-inputtext-sm" />

<Dropdown :filter="true" v-if="inputfield.type=='select' || inputfield.type=='multiselect'|| inputfield.type=='listselect'|| inputfield.type=='boolean'" v-model="condition.numerical_val" :options="inputfield.options" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" />
<!-- condition value-->

</template>

<!-- condition operation-->
<Dropdown  v-if="inputfield.type=='number'" v-model="condition.execution_type" :options="numberoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>

<Dropdown  v-if="inputfield.type=='text' || inputfield.type=='longtext'" v-model="condition.execution_type" :options="textoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>

<Dropdown  v-if="inputfield.type=='select' || inputfield.type=='multiselect'|| inputfield.type=='listselect'|| inputfield.type=='boolean'" v-model="condition.execution_type" :options="selectoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>

<Dropdown  v-if="inputfield.type=='columns' && condition.inputfieldcolumn_id" v-model="condition.execution_type" :options="numberoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>
<!-- condition operation-->


</template>

<!-- comparison type selected-->




</template>
<!-- inputfield -->

<!-- customattribute -->

<template v-if="customattribute">
<span class="ml-2">özel niteliği için girilen değer, </span>
<!-- condition value-->
<InputNumber   placeholder="Sayısal değer" v-if="customattribute.type=='number'" v-model="condition.numerical_val" class="ml-2 p-inputtext-sm  mt-2" />

<InputText  type="text" placeholder="Text değeri" v-if="customattribute.type=='string'" v-model="condition.text_val" class="ml-2 p-inputtext-sm" />

<Dropdown :filter="true" v-if="customattribute.type=='select'" v-model="condition.numerical_val" :options="customattribute.options" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" />

<Dropdown :filter="true" v-if="customattribute.type=='boolean'" v-model="condition.numerical_val" :options="booleanoptions" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" />



<!-- condition value-->

<!-- condition operation-->
<Dropdown  v-if="customattribute.type=='number'" v-model="condition.execution_type" :options="numberoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>

<Dropdown  v-if="customattribute.type=='string'" v-model="condition.execution_type" :options="textoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>

<Dropdown  v-if="customattribute.type=='select' || customattribute.type=='boolean'" v-model="condition.execution_type" :options="selectoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>
<!-- condition operation-->

</template>

<!-- customattribute -->

<!-- nonconformitytype -->

<template v-if="nonconformitytype">
<template v-if="classes.length">
	<Dropdown   v-model="condition.class_id" :options="classes" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm  mt-2" />
	<span class="ml-2">sınıfı </span>
</template>

<span class="ml-2">uygunsuzluk sayısı, </span>
<InputNumber   placeholder="Sayısal değer" v-model="condition.numerical_val" class="ml-2 p-inputtext-sm" />

<Dropdown   v-model="condition.execution_type" :options="numberoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>
</template>

<!-- nonconformitytype -->

<!-- customcalculation -->
<template v-if="customcalculation">
<span class="ml-2">puanı, </span>

<Dropdown :filter="true"  v-model="condition.comparison_type" :options="calculation_comparison_types" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm  mt-2" 
/>

<template v-if="condition.comparison_type">

	<template v-if="condition.comparison_type=='calculation'">
	<Dropdown :filter="true"   v-model="condition.comparison_calculation_id" :options="customcalculations" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm"  />		
	</template>
	<template v-if="condition.comparison_type=='value'">
		<InputNumber   placeholder="Sayısal değer"  v-model="condition.numerical_val" class="ml-2 p-inputtext-sm" />
	</template>

	<Dropdown   v-model="condition.execution_type" :options="numberoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="conditionExecutionSelected"/>

</template>


</template>
<!-- customcalculation -->

<template v-if="ready_to_include">
<Dropdown  v-model="condition.operator" :options="conditionoperators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm  mt-2" @change="conditionOperatorSelected"/>

</template>

 
</div>

<div class="col-1">
<Button v-if="show_delete" icon="pi pi-trash"  class=" p-button-danger p-button-outlined  p-button-sm " @click="removeCondition"/>
</div>

</div>
</template>

<script>

export default {

  name: 'Questionlistconditionline',
  props:["conditiondata","inputfields","customattributes","questionlists","nonconformitytypes","classes","customcalculations"],
  data () {
    return {
    	condition:null,
    	inputfield:null,
    	inputfieldcolumn:null,
    	customattribute:null,
    	nonconformitytype:null,
    	customcalculation:null,
    	comparisoninputfield:null,
    	comparison_types:[
    	{name:"Soru",code:"inputfield"},
    	{name:"Tam Değer",code:"value"},
    	],
    	calculation_comparison_types:[
    	{name:"Hesaplama",code:"calculation"},
    	{name:"Tam Değer",code:"value"},
    	],
    	textoperators:[
    	{name:"Terimini içeriyorsa",code:"includes"},
    	{name:"Terimini içermiyorsa",code:"does_not_include"},
    	],
    	numberoperators:[
    	{name:"değerine eşitse",code:"equal_to"},
    	{name:"değerine eşit değilse",code:"not_equal_to"},
    	{name:"değerinden büyükse",code:"greater_than"},
    	{name:"değerinden küçükse",code:"less_than"},
    	{name:"değer girildiyse",code:"inpu_filled"},
    	],
    	columnoperators:[
    	{name:"değeri doldurulduysa",code:"column_filled"},
    	{name:"girilen değer",code:"check_entered_val"},
    	],
    	selectoperators:[
    	{name:"değerine eşitse",code:"equal_to"},
    	{name:"değerine eşit değilse",code:"not_equal_to"},
    	],
    	booleanoptions:[
    	{name:"Açık",code:1},
    	{name:"Kapalı",code:0},
    	],
    	conditionoperators:[
    	{name:"ve",code:"and"},
    	{name:"ya da",code:"or"},
    	{name:"tamamla",code:"execute"},
    	],
    	ready_to_include:false,
    	show_delete:true,
    }
  },
  computed:{
  		types()
  		{
  			console.log("types")
  			console.log(this.$store.state.questionlists.questionlist)
  			if(this.$store.state.questionlists.questionlist.multiple_calculations)
  			{
  				return [
			    	{name:"Soru",code:"inputfield"},
			    	{name:"Özel Nitelik",code:"customattribute"},
			    	{name:"Uygunsuzluk",code:"nonconformitytype"},
			    	{name:"Özel Hesaplama",code:"customcalculation"},
			    	]
  			}
  			return [
		    	{name:"Soru",code:"inputfield"},
		    	{name:"Özel Nitelik",code:"customattribute"},
		    	{name:"Uygunsuzluk",code:"nonconformitytype"},
		    	]
  		},
  },
  watch:{
  	conditiondata(newval)
  	{
  		console.log("watch")
  		this.resolveCondition()
  	}
  },
  mounted()
  {
  		console.log("mounted")
  		this.resolveCondition()
  },
  methods:{  	
  	inputfieldColumnSelected(data)
  	{
  		this.inputfieldcolumn = this.inputfield.columns.find(item=>item.id == data.value)
  		console.log(this.inputfieldcolumn)
  	},
  	resolveCondition(newval)
  	{
  		this.condition = this.conditiondata
  		if(this.condition.customcalculation_id)
  		{
  				this.customcalculation = this.customcalculations.find((item)=>{return item.id == this.condition.customcalculation_id})
  				this.ready_to_include = true
  				this.show_delete = true
  		}
  		if(this.condition.nonconformitytype_id)
  		{
  			let nonconformitytype = this.nonconformitytypes.find((item)=>{return item.id == this.condition.nonconformitytype_id})
  			
    	
    		this.nonconformitytype = nonconformitytype

  			this.ready_to_include = true
  			this.show_delete = true
  		}
  		if(this.condition.inputfield_id)
  		{
  			let inputfield = this.inputfields.find((item)=>{return item.id == this.condition.inputfield_id})
  			if(inputfield.options.length)
	    	{
	    		for(let option of inputfield.options)
			      {
			      	if(option.name.length>60)
			        {
			            option.name = option.name.substring(0, 60)+"...";
			        }
			      }
	    	}
	    	this.inputfield = inputfield

	    	if(this.condition.inputfieldcolumn_id)
	    	{
	    		this.inputfieldcolumn = this.inputfield.columns.find(item=>item.id == this.condition.inputfieldcolumn_id)
	    	}
    	
    		

  			this.ready_to_include = true
  			this.show_delete = true
  		}
  		if(this.condition.customattribute_id)
  		{
  			let customattribute = this.customattributes.find((item)=>{return item.id == this.condition.customattribute_id})
  			if(customattribute.options.length)
	    	{
	    		for(let option of customattribute.options)
			      {
			      	if(option.name.length>60)
			        {
			            option.name = option.name.substring(0, 60)+"...";
			        }
			      }
	    	}
    	
    		this.customattribute = customattribute

  			this.ready_to_include = true
  			this.show_delete = true
  		}
  	},
  	comparisonInputfieldSelected()
  	{
  		this.comparisoninputfield  = this.inputfields.find((item)=>{return item.id == this.condition.comparison_inputfield_id}) 
  	},
    conditionInputfieldSelected(id)
    {
    	this.customattribute = null
    	this.customattribute_id = null
    	let inputfield  = this.inputfields.find((item)=>{return item.id == this.condition.inputfield_id})
    	console.log(inputfield)

    	this.condition.execution_type = null
    	this.condition.numerical_val = null
    	this.condition.text_val = null
    	this.condition.operator = null
    	this.ready_to_include = false
    	if(inputfield.options.length)
    	{
    		for(let option of inputfield.options)
		      {
		      	if(option.name.length>30)
		        {
		            option.name = option.name.substring(0, 30)+"...";
		        }
		      }
    	}
    	
    	this.inputfield = inputfield
    },
    conditionNonconformityTypeSelected(id)
    {
    	let nonconformitytype  = this.nonconformitytypes.find((item)=>{return item.id == this.condition.nonconformitytype_id})
    	this.condition.execution_type = null
    	this.condition.numerical_val = null
    	this.nonconformitytype = nonconformitytype
    },
    conditionCustomCalculationTypeSelected(id)
    {
    	this.customcalculation  = this.customcalculations.find((item)=>{return item.id == this.condition.customcalculation_id})
    },
    conditionCustomattributeSelected(id)
    {

    	this.inputfield = null
    	this.inputfield_id = null
    	let customattribute  = this.customattributes.find((item)=>{return item.id == this.condition.customattribute_id})
    	console.log(customattribute)

    	this.condition.execution_type = null
    	this.condition.numerical_val = null
    	this.condition.text_val = null
    	this.condition.operator = null
    	this.ready_to_include = false
    	if(customattribute.options.length)
    	{
    		for(let option of customattribute.options)
		      {
		      	if(option.name.length>30)
		        {
		            option.name = option.name.substring(0, 30)+"...";
		        }
		      }
    	}
    	
    	this.customattribute = customattribute

    },
    conditionExecutionSelected()
    {
    	this.ready_to_include = true
    },
    conditionOperatorSelected()
    {

    	this.show_delete = true
    	this.$emit("conditionConcluded",this.condition)
    },
    removeCondition()
    {
    	this.$emit("removeCondition",this.condition)
    },
  },

}
</script>

<style lang="css" scoped>
</style>